import {
  FormControl,
  FormControlProps,
  FormLabel,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import * as React from 'react';

import { SelectButton } from '@/components/SelectButton';
import { UserSearchInput_Filter_EAccountStatus } from '@/graphql-types/globalTypes';

const text = {
  [UserSearchInput_Filter_EAccountStatus.NOT_INVITED]: 'Not Invited',
  [UserSearchInput_Filter_EAccountStatus.INVITED]: 'Invited',
  [UserSearchInput_Filter_EAccountStatus.ACTIVE]: 'Active',
};

type IAccountStatusProps = {
  value: UserSearchInput_Filter_EAccountStatus[];
  onChange: (value: UserSearchInput_Filter_EAccountStatus[]) => void;
} & Omit<FormControlProps, 'value' | 'onChange'>;

export const AccountStatus: React.FC<IAccountStatusProps> = ({
  value,
  onChange,
  ...props
}) => (
  <FormControl {...props}>
    <FormLabel textStyle="detailStrong">Account Status</FormLabel>
    <Menu closeOnSelect={false}>
      <MenuButton as={SelectButton} variant="menu">
        {value.length === 0
          ? 'All'
          : value.length === 1
          ? text[value[0] as keyof typeof text] ?? value[0]
          : `(${value.length}) Selected`}
      </MenuButton>
      <MenuList>
        <MenuOptionGroup value={value} onChange={onChange} type="checkbox">
          <MenuItemOption
            value={UserSearchInput_Filter_EAccountStatus.NOT_INVITED}
          >
            {text[UserSearchInput_Filter_EAccountStatus.NOT_INVITED]}
          </MenuItemOption>
          <MenuItemOption value={UserSearchInput_Filter_EAccountStatus.INVITED}>
            {text[UserSearchInput_Filter_EAccountStatus.INVITED]}
          </MenuItemOption>
          <MenuItemOption value={UserSearchInput_Filter_EAccountStatus.ACTIVE}>
            {text[UserSearchInput_Filter_EAccountStatus.ACTIVE]}
          </MenuItemOption>
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  </FormControl>
);
